import { Api } from "@mcleod/core";
import { AutogenLayoutDeposit } from "./autogen/AutogenLayoutDeposit";
import { ClickEvent, Snackbar, DataSourceModeChangeEvent, DataSourceMode, PrintableEvent, BlurEvent } from "@mcleod/components";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "cash_batch",
    screenName: "Deposit",
    navigateToUrl: "lme/ar/cashreceipts/deposit",
};

export class Deposit extends AutogenLayoutDeposit {

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    /** This is an event handler for the onClick event of buttonButton1. */
    buttonNextDepositOnClick(event: ClickEvent) {
        this.buttonNextDeposit.busy = true;

        Api.post("lme/ar/cashreceipts/get-next-deposit-no").then((response) => {
            if (response && response.data) {
                const depositNo = response.data[0].id;

                this.activeRow.set("id", depositNo.toString().padStart(8, '0'));
            }
        }).catch((error) => {
            Snackbar.showWarningSnackbar("Error fetching next deposit number:", error);
        }).finally(() => {
            this.buttonNextDeposit.busy = false;
        });

    }

    /** This is an event handler for the afterModeChange event of sourceDeposits. */
    sourceDepositsAfterModeChange(event: DataSourceModeChangeEvent) {
        this.buttonNextDeposit.visible = (event.newMode === DataSourceMode.ADD);
        this.panelTotals.visible = (event.newMode !== DataSourceMode.ADD);
    }

    leftAlignContent(event: PrintableEvent) {
        if (event.printableLabel) {
            event.printableLabel.style.justifyContent = "left";
        }
    }

     /** This is an event handler for the onBlur event of textboxAmount. */
    textboxAmountOnBlur(event: BlurEvent) {
        this.updateUnappliedAmount();
    }

    updateUnappliedAmount() {
        if (this.activeRow) {
            if (this.activeRow.isNull("amount")) {
                this.activeRow.set("unapplied_total", null);
                return;
            }
            const receiptsTotal  = this.activeRow.getCurrency("receipts_total", 0);
            const amount = this.activeRow.getCurrency("amount", 0);
            amount.subtract(receiptsTotal);
            this.activeRow.set("unapplied_total", amount);
        }

    }
}
